import { useEffect, useState } from "react";
import axiosInstance from "../../api/axios.js";
import AuthTravelShell from "../../components/travel-theme/AuthTravelShell.js";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ResetRequest = () => {
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setValidEmail(EMAIL_REGEX.test(email.trim()));
  }, [email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const normalizedEmail = email.trim();
    try {
      const response = await axiosInstance.post("/api/auth/reset_password", {
        email: normalizedEmail,
      });
      setMessage(response.data.message);
    } catch (error) {
      setMessage(error.response.data.message);
    }
  };

  return (
    <AuthTravelShell
      eyebrow="Account recovery"
      title="Find your ticket."
      description="Enter the email connected to your HackPrinceton account and we will send your recovery link."
      ticketCode="RESET"
    >
      <form className="auth-form" onSubmit={handleSubmit}>
        <p className="subtitle">
          We will send recovery instructions to your verified account email.
        </p>
        <div className="auth-form-inner">
          {message && (
            <p className="error-message" role="status">
              {message}
            </p>
          )}
          <div className="form-field">
            <label htmlFor="reset-email">Account email</label>
                <input
                  id="reset-email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  aria-invalid={email && !validEmail ? "true" : "false"}
                  aria-describedby={email && !validEmail ? "reset-email-error" : undefined}
                  required
                />
          </div>
          {email && !validEmail && (
            <p id="reset-email-error" className="error-message">
              Enter a valid email address.
            </p>
          )}
          <div className="auth-form__lower">
            <button type="submit" className="button" disabled={!validEmail}>
              Send recovery link
            </button>
          </div>
        </div>
      </form>
    </AuthTravelShell>
  );
};

export default ResetRequest;
